import { addDays, set, setDayOfYear, startOfYear } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';

export function getDayMonthOfYear(
  dayOfYear: number,
  year?: number,
  hour?: string,
  minute?: string,
  timeZone?: string
): Date {
  if (year && !Number.isNaN(year)) {
    return createZonedDateFromOrdinal(
      year,
      dayOfYear,
      Number(hour),
      Number(minute),
      timeZone ?? 'UTC'
    );
  }
  const startOfYearUTC = fromZonedTime(startOfYear(new Date()), 'UTC');
  return setDayOfYear(startOfYearUTC, dayOfYear);
}

function createZonedDateFromOrdinal(
  year: number,
  dayOfYear: number,
  hour: number,
  minute: number,
  timeZone: string
): Date {
  const localDate = addDays(startOfYear(new Date(year, 0, 1)), dayOfYear);

  const localWithTime = set(localDate, {
    hours: hour,
    minutes: minute,
    seconds: 0,
    milliseconds: 0
  });

  return fromZonedTime(localWithTime, timeZone);
}
